import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "time-open",
  "use": "time-open-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"time-open\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M32 48a16 16 0 1116-16 16 16 0 01-16 16zm2-16V22a2 2 0 00-4 0v12a2 2 0 002 2h6a2 2 0 000-4z\" /><circle cx=\"32\" cy=\"32\" r=\"30\" fill=\"none\" stroke=\"var(--bolt-theme-icon, currentColor)\" stroke-width=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol